module.exports = __webpack_public_path__ + "img/trash.592a9fd9.svg";